import { useNavigate, useSearchParams } from "react-router-dom";
import { useAppSelector } from "../app/hooks";
import { CognitoUserGroups } from "../features/Users/userUtils";
import { selectUserCognitoGroups } from "../features/Users/usersSlice";
import { useEffect } from "react";
import { DeepLinkValues } from "../app/constants";

export const RootRedirect = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const deepLinkValue = searchParams.get("deep_link_value");

  const permissions = useAppSelector(selectUserCognitoGroups);

  const isUser = permissions?.includes(CognitoUserGroups.Users);
  const isProgramAdmin = permissions?.includes(CognitoUserGroups.ProgramAdmins);
  const isSysAdmin = permissions?.includes(CognitoUserGroups.SysAdmins);

  useEffect(() => {
    // Handle deep_link_value from AppsFlyer OneLink redirects (assessment emails)
    if (
      deepLinkValue === DeepLinkValues.ASSESSMENT_REQUESTED ||
      deepLinkValue === DeepLinkValues.ASSESSMENT_COMPLETED
    ) {
      // Assessment links should go to pending assessments
      // but only if user has access to that route
      if (isUser) {
        navigate("/assessments/pending");
        return;
      }
      // If admin doesn't have Users permission, fall through to permission-based routing
    }

    // Default permission-based routing (when no deep_link_value or user lacks access)
    if (isSysAdmin || isProgramAdmin) {
      navigate("/users");
      return;
    }
    if (isUser) {
      navigate("/assessments/pending");
      return;
    }
  }, [deepLinkValue, isSysAdmin, isProgramAdmin, isUser, navigate]);

  return null;
};
